import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as mainActions from '../../actions/mainActions';
import { Avatar, Grid, Button, FormControl, TextField, Card } from 'material-ui';
import ArrowBack from 'material-ui-icons/ArrowBack';
import { withStyles } from 'material-ui/styles';
import moment from 'moment';
import '../../App.css';
import { GROUP_TYPES, AGE_RANGES, TRAVEL_REASON, ACCOMODATION, CONSULT_REASONS, TRANSPORTS } from '../../config/constants';
import { saveSurveys } from '../../controllers/surveys';
import { Save } from '@material-ui/icons';
import { requestSurvey } from '../../controllers/surveys';
import DateTimePickerCustom from '../displayComponents/DateTimePickerCustom';
import SelectComponent from '../displayComponents/SelectComponent';
import RadioButtonComponent from '../displayComponents/RadioButtonComponent';
import CheckBoxComponent from '../displayComponents/CheckBoxComponent';
import { toast } from 'react-toastify';

class Survey extends Component {

    constructor(props) {
        super(props);
        this.state = {
            enquisa: {
                age: {},
                travel_reason: [],
                transport: [],
                overnight_accommodation: [],
                consult_reason: [],
                survey_date: moment().format('DD/MM/YYYY HH:mm:ss'),
                lang: -1,
                origin: 140,
                postal_code: "",
                group_type: -1,
                group_number: "",
                overnights: -1,
                first_time: -1,
                disability: -1,
                duration: "",
                office_id: -1,
                municipality_id: -1
            },
            errors: {
                age: "",
                travel_reason: "",
                transport: "",
                overnight_accommodation: "",
                consult_reason: "",
                lang: "",
                origin: "",
                postal_code: "",
                group_type: "",
                group_number: "",
                overnights: "",
                first_time: "",
                disability: "",
                duration: "",
                office_id: "",
                municipality_id: ""
            },
            formDisabled: false,
            office: -1,
            municipality: -1
        }
    }

    componentDidMount() {
        const { sessionData } = this.props.main;

        document.addEventListener('keydown', this.handleKeydown);
        const id = parseInt(this.props.id, 10);
        if (id) {
            this.loadSurvey(id);
            this.setState({ formDisabled: true });
        } else {
            if (sessionData.municipality){
                this.setState({ enquisa: { ...this.state.enquisa,  municipality_id: sessionData.municipality, office_id: sessionData.office} })
            }
        }
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeydown);
    }

    handleKeydown = event => {
        if (event.keyCode === 13) this.validateFields();
    }

    loadSurvey = async (id) => {
        try {
            let survey = await requestSurvey(this.props.main.sessionData.userName, this.props.main.sessionData.passwd, { type: 'survey', id: id });
            this.setState({ enquisa: survey.result.data[0] });
        } catch (err) {
            console.error(err);
        }
    }

    setDate = (date) => {
        const { enquisa } = this.state;
        enquisa.survey_date = date.format('DD/MM/YYYY HH:mm:ss');
        this.setState({ enquisa });
    }

    setValue = (event) => {
        const { enquisa, errors } = this.state;
        if (event.target.name === "origin" && "" + event.target.value !== "140") {
            enquisa.postal_code = "";
            errors.postal_code = "";
        }
        enquisa[event.target.name] = event.target.value;
        this.setState({ enquisa });
    }

    setAgeRange = (event) => {
        const { enquisa } = this.state;
        if (event.target.value === "") delete enquisa.age[event.target.name];
        else enquisa.age[event.target.name] = event.target.value;
        this.setState({ enquisa });
    }

    setTravelReason = (event) => {
        const { enquisa } = this.state;
        let index = enquisa.travel_reason.indexOf("" + event.target.value);
        if (event.target.checked) enquisa.travel_reason.push("" + event.target.value);
        else enquisa.travel_reason.splice(index, 1);
        this.setState({ enquisa });
    }

    setAccomodation = (event) => {
        const { enquisa } = this.state;
        let index = enquisa.overnight_accommodation.indexOf("" + event.target.value);
        if (event.target.checked) enquisa.overnight_accommodation.push("" + event.target.value);
        else enquisa.overnight_accommodation.splice(index, 1);
        this.setState({ enquisa });
    }

    setConsultReason = (event) => {
        const { enquisa } = this.state;
        let index = enquisa.consult_reason.indexOf("" + event.target.value);
        if (event.target.checked) enquisa.consult_reason.push("" + event.target.value);
        else enquisa.consult_reason.splice(index, 1);
        this.setState({ enquisa });
    }

    setTransport = (event) => {
        const { enquisa } = this.state;
        let index = enquisa.transport.indexOf("" + event.target.value);
        if (event.target.checked) enquisa.transport.push("" + event.target.value);
        else enquisa.transport.splice(index, 1);
        this.setState({ enquisa });
    }

    saveSurvey = async () => {
        try {
            let { enquisa } = this.state;
            const { sessionData } = this.props.main;
            enquisa.terminal_id = this.props.main.terminal_id;
            const data = {
                username: sessionData.userName,
                passwd: sessionData.passwd,
                terminal_id: sessionData.terminal_id,
                surveys: [enquisa]
            }
            let response = await saveSurveys(data);
            if (response.code === 200) toast("Enquisa gardada correctamente", { autoClose: 3000, className: "toast-success" });
            else {
                console.error(response);
                return toast("Produciuse un erro ao gardar a enquisa", { autoClose: 3000, className: "toast-error" });
            }
            let updatedData = {
                age: {},
                travel_reason: [],
                transport: [],
                overnight_accommodation: [],
                consult_reason: [],
                survey_date: enquisa.survey_date,
                lang: -1,
                origin: -1,
                postal_code: "",
                group_type: -1,
                group_number: "",
                overnights: -1,
                first_time: -1,
                disability: -1,
                duration: "",
                office_id: enquisa.office_id,
                municipality_id: enquisa.municipality_id
            }
            this.setState({ enquisa: updatedData }, ()=>{
                this.props.refresh();
                this.props.close();
            });
        } catch (err) {
            console.error(err);
        }
    }

    validateFields = () => {
        const { enquisa } = this.state;
        let errors = {};
        if (enquisa.municipality_id === -1) errors.municipality_id = "Selecciona un concello";
        if (enquisa.office_id === -1) errors.office_id = "Selecciona unha oficina";
        if (enquisa.lang === -1) errors.lang = "Selecciona un idioma da lista";
        if (enquisa.origin === -1) errors.origin = "Selecciona un país de orixen";
        if ("" + enquisa.origin === "140" && enquisa.postal_code === "") errors.postal_code = "Debes cubrir este campo para continuar";
        if (enquisa.group_type === -1) errors.group_type = "Selecciona un tipo de grupo";
        if (enquisa.group_number === "" || parseInt(enquisa.group_number, 10) === 0) errors.group_number = "Indica o número de persoas";
        else {
            let total = 0;
            Object.keys(enquisa.age).forEach((range) => {
                total += +enquisa.age[range];
            });
            if (total === 0 || total === "" || total !== +enquisa.group_number) errors.age = "O total de persoas por idades debe coincidir co total do grupo";
        }
        if (enquisa.duration === "" || enquisa.duration === 0) errors.duration = "Indica a duración da viaxe";
        if (enquisa.first_time === -1) errors.first_time = "Selecciona unha opción";
        if (enquisa.overnights === -1) errors.overnights = "Selecciona unha opción";
        if (enquisa.overnights !== "2" && enquisa.overnight_accommodation.length === 0) errors.overnight_accommodation = "Selecciona unha opción";
        if (enquisa.disability === -1) errors.disability = "Selecciona unha opción";
        //if (!errors.postal_code && enquisa.postal_code.length !== 5) errors.postal_code = "El código postal debe tener 5 cifras";

        this.setState({ errors }, () => {
            let errorFlag = false;
            Object.keys(this.state.errors).forEach((error) => {
                if (this.state.errors[error] && this.state.errors[error] !== "") errorFlag = true;
            });
            if (errorFlag === true) toast("Por favor, revise os datos do formulario", { className: "toast-error" });
            else this.saveSurvey();
        });
    }

    render() {
        const { iconBack, gridQuestion, ageRangeInput, formCard, gridAgeRange, customLabel, iconSave, labelError } = customStyles;
        const { enquisa, errors, formDisabled } = this.state;
        const { classes, close } = this.props;
        const { languages, countries, sessionData, offices, municipalities } = this.props.main;
        const id = parseInt(this.props.id, 10);
        return (
            <Fragment>
                <Grid container >
                    <Grid item xs={2}>
                        <Button size="large" style={{
                            backgroundColor: "#DDD",
                            marginTop: '0.5em',
                            marginLeft: '0'
                        }} onClick={() => close()}><ArrowBack style={iconBack} /> Voltar</Button>
                    </Grid>
                    {id > 0 ?
                        <Fragment>
                            <Grid item style={gridQuestion} xs={6}>
                                <p>Concello: <b>{enquisa.municipality_name}</b>, Oficina: <b>{enquisa.office_name}</b></p>
                            </Grid>
                            <Grid item style={gridQuestion} xs={4}>
                                <p>Usuario: <b>{enquisa.user_name}</b></p>
                            </Grid>
                        </Fragment>
                        :
                        <Fragment>
                            <Grid item style={gridQuestion} xs={6}>
                                <SelectComponent
                                    disabled={formDisabled || sessionData.municipality}
                                    label="Concello"
                                    defaultValue="Todos"
                                    items={municipalities}
                                    value={enquisa.municipality_id}
                                    fieldValue="id"
                                    fieldName="name"
                                    name="municipality_id"
                                    setValue={this.setValue}
                                    error={errors.municipality_id} />
                                <SelectComponent
                                    label="Oficina"
                                    defaultValue="Todas"
                                    items={(!!enquisa.municipality_id && enquisa.municipality_id != -1) ? offices.filter((office) => { return office.municipality_id === enquisa.municipality_id }) : offices}
                                    value={enquisa.office_id}
                                    fieldValue="id"
                                    fieldName="name"
                                    name="office_id"
                                    setValue={this.setValue}
                                    error={errors.office_id} />
                            </Grid>
                            <Grid item style={gridQuestion} xs={4}>
                                <p>Usuario: <b>{sessionData.name}</b></p>
                            </Grid>
                        </Fragment>
                    }
                </Grid>
                <Grid container >
                    <Card style={formCard}>
                        <Grid style={gridQuestion} item lg={3}>
                            <Avatar className={classes.avatar}>1</Avatar>
                            <DateTimePickerCustom
                                label="Data da enquisa"
                                value={enquisa.survey_date}
                                format='DD/MM/YYYY HH:mm:ss'
                                setDate={this.setDate}
                                disabled={formDisabled ? true : false}
                                displayFormat="LLL" />
                        </Grid>
                        <Grid style={gridQuestion} item lg={3}>
                            <Avatar className={classes.avatar}>2</Avatar>
                            <SelectComponent
                                items={languages}
                                label="Idioma"
                                name="lang"
                                id="idioma"
                                value={enquisa.lang}
                                setValue={this.setValue}
                                fieldName="name"
                                fieldValue="value"
                                error={errors.lang}
                                disabled={formDisabled ? true : false}
                            />
                        </Grid>
                        <Grid style={gridQuestion} item lg={3}>
                            <Avatar className={classes.avatar}>3</Avatar>
                            <SelectComponent
                                items={countries}
                                label="País de orixe"
                                name="origin"
                                id="origin"
                                value={enquisa.origin}
                                setValue={this.setValue}
                                fieldName="name_gl"
                                fieldValue="id"
                                error={errors.origin}
                                disabled={formDisabled ? true : false}
                            />
                        </Grid>
                        <Grid item style={gridQuestion} lg={3}>
                            <Avatar className={classes.avatar}>4</Avatar>
                            <FormControl className={classes.formControl}>
                                <TextField
                                    id="postal-code"
                                    name="postal_code"
                                    label="Código postal"
                                    value={enquisa.postal_code ? enquisa.postal_code : ""}
                                    margin="dense"
                                    type="number"
                                    onChange={this.setValue}
                                    helperText={errors.postal_code && errors.postal_code !== "" ? errors.postal_code : ""}
                                    error={errors.postal_code && errors.postal_code !== "" ? true : false}
                                    disabled={"" + enquisa.origin !== "140" || formDisabled ? true : false}
                                />
                            </FormControl>
                        </Grid>
                    </Card>
                </Grid>
                <Card style={formCard}>
                    <Grid style={gridQuestion} item lg={2}>
                        <Avatar className={classes.avatar}>5</Avatar>
                        <div style={{ marginLeft: '-2.5em' }}>
                            <SelectComponent
                                items={GROUP_TYPES}
                                label="Tipo de grupo"
                                name="group_type"
                                id="group_type"
                                value={"" + enquisa.group_type}
                                setValue={this.setValue}
                                fieldName="text"
                                fieldValue="value"
                                error={errors.group_type}
                                disabled={formDisabled ? true : false}
                            />
                        </div>
                    </Grid>
                    <Grid item style={gridQuestion} lg={2}>
                        <Avatar className={classes.avatar}>6</Avatar>
                        <div style={{ marginLeft: '-1.5em' }}>
                            <FormControl className={classes.formControl}>
                                <TextField
                                    id="group_number"
                                    name="group_number"
                                    label="Tamaño do grupo"
                                    value={enquisa.group_number ? enquisa.group_number : ""}
                                    margin="dense"
                                    type="number"
                                    inputProps={{min: 0, max: 1000}}
                                    onChange={this.setValue}
                                    helperText={errors.group_number && errors.group_number !== "" ? errors.group_number : ""}
                                    error={errors.group_number && errors.group_number !== "" ? true : false}
                                    disabled={formDisabled ? true : false}
                                />
                            </FormControl>
                        </div>
                    </Grid>
                    <Grid item style={gridAgeRange} lg={8}>
                        <Avatar className={classes.avatar}>7</Avatar>
                        <p style={customLabel}>Número de persoas por idade</p>
                        {AGE_RANGES.map((range) => {
                            return (
                                <TextField
                                    id={`range_${range.value}`}
                                    key={`range_${range.value}`}
                                    name={range.value}
                                    label={range.text}
                                    value={enquisa.age[parseInt(range.value, 10)] ? enquisa.age[parseInt(range.value, 10)] + "" : ""}
                                    margin="dense"
                                    type="number"
                                    inputProps={{min: 0}}
                                    onChange={this.setAgeRange}
                                    style={ageRangeInput}
                                    disabled={formDisabled ? true : false}
                                />
                            )
                        })}
                        <p style={labelError}>{errors.age}</p>
                    </Grid>
                </Card>
                <Card style={formCard}>
                    <Grid style={gridQuestion} item lg={2}>
                        <Avatar className={classes.avatar}>8</Avatar>
                        <div style={{ marginLeft: '-3.5em', marginRight: '-2em' }}>
                            <FormControl className={classes.formControl}>
                                <TextField
                                    id="duration"
                                    name="duration"
                                    label="Duración da viaxe"
                                    value={enquisa.duration}
                                    inputProps={{min: 0, max: 1000}}
                                    margin="dense"
                                    type="number"
                                    onChange={this.setValue}
                                    helperText={errors.duration && errors.duration !== "" ? errors.duration : ""}
                                    error={errors.duration && errors.duration !== "" ? true : false}
                                    disabled={formDisabled ? true : false}
                                />
                            </FormControl>
                        </div>
                    </Grid>
                    <Grid style={gridQuestion} item lg={2}>
                        <Avatar className={classes.avatar}>9</Avatar>
                        <RadioButtonComponent
                            id="radioGroupFirstTime"
                            name="first_time"
                            setValue={this.setValue}
                            options={[{ label: "Si", value: "1" }, { label: "Non", value: "2" }]}
                            value={enquisa.first_time + ""}
                            label="¿Primeira vez en Arousa Norte?"
                            error={errors.first_time}
                            disabled={formDisabled ? true : false}
                        />
                    </Grid>
                    <Grid style={gridQuestion} item lg={8}>
                        <Avatar className={classes.avatar}>10</Avatar>
                        <CheckBoxComponent
                            id="travel_reason"
                            classTitle="customLabel"
                            classForm="formReason"
                            classChecked="formChecked"
                            items={TRAVEL_REASON}
                            values={enquisa.travel_reason}
                            setValue={this.setTravelReason}
                            label="Motivación da viaxe"
                            error={errors.travel_reason}
                            disabled={formDisabled ? true : false}
                        />
                    </Grid>
                </Card>
                <Card style={formCard}>
                    <Grid style={gridQuestion} item lg={2}>
                        <Avatar className={classes.avatar}>11</Avatar>
                        <RadioButtonComponent
                            id="radioGroupOvernight"
                            name="overnights"
                            setValue={this.setValue}
                            options={[{ label: "Si", value: "1" }, { label: "Non", value: "2" }]}
                            value={enquisa.overnights + ""}
                            label="Pernocta"
                            error={errors.overnights}
                            disabled={formDisabled ? true : false}
                        />
                    </Grid>
                    <Grid style={gridQuestion} item lg={10}>
                        <Avatar className={classes.avatar}>12</Avatar>
                        <CheckBoxComponent
                            id="accomodation"
                            classTitle="customLabel"
                            classForm="formReason"
                            classChecked="formChecked"
                            items={ACCOMODATION}
                            values={enquisa.overnight_accommodation}
                            setValue={this.setAccomodation}
                            label="Aloxamento"
                            error={errors.overnight_accommodation}
                            disabled={"" + enquisa.overnights === "2" || formDisabled ? true : false}
                        />
                    </Grid>
                </Card>
                <Card style={formCard}>
                    <Grid style={gridQuestion} item lg={2}>
                        <Avatar className={classes.avatar}>13</Avatar>
                        <RadioButtonComponent
                            id="radioGroupDisability"
                            name="disability"
                            setValue={this.setValue}
                            options={[{ label: "Si", value: "1" }, { label: "Non", value: "2" }]}
                            value={enquisa.disability + ""}
                            label="Discapacidade"
                            error={errors.disability}
                            disabled={formDisabled ? true : false}
                        />
                    </Grid>
                    <Grid style={gridQuestion} item lg={6}>
                        <Avatar className={classes.avatar}>14</Avatar>
                        <CheckBoxComponent
                            id="consult_reason"
                            classTitle="customLabel"
                            classForm="formReason"
                            classChecked="formChecked"
                            items={CONSULT_REASONS}
                            values={enquisa.consult_reason}
                            setValue={this.setConsultReason}
                            label="Motivo da consulta"
                            error={errors.consult_reason}
                            disabled={formDisabled ? true : false}
                        />
                    </Grid>
                    <Grid item style={gridQuestion} lg={4}>
                        <Avatar className={classes.avatar}>15</Avatar>
                        <CheckBoxComponent
                            id="transport"
                            classTitle="customLabel"
                            classForm="formReason"
                            classChecked=""
                            items={TRANSPORTS}
                            values={enquisa.transport}
                            setValue={this.setTransport}
                            label="Medio de transporte empregado"
                            error={errors.transport}
                            disabled={formDisabled ? true : false}
                        />
                    </Grid>
                </Card>
                {!id &&
                    <Grid item xs={12}>
                        <Button style={{ float: 'right' }} size="large" variant="raised" color="secondary" onClick={this.validateFields}>
                            <Save style={iconSave} />Gardar</Button>
                    </Grid>
                }
            </Fragment>
        );
    }
}

const customStyles = {
    iconBack: {
        fontSize: "1.15rem",
        marginRight: "0.5rem"
    },
    containerDate: {
        textAlign: "center"
    },
    gridQuestion: {
        paddingBottom: "2rem",
        textAlign: "center",
        justifyContent: "center",
        display: "flex",
        alignItems: "center"
    },
    ageRangeInput: {
        maxWidth: "23%",
        paddingRight: "1rem"
    },
    formCard: {
        width: "100%",
        display: "flex",
        paddingTop: "1.2rem",
        marginBottom: "1.2rem",
        paddingLeft: "1rem"
    },
    gridAgeRange: {
        paddingBottom: "2rem",
        textAlign: "center"
    },
    customLabel: {
        margin: 0
    },
    formChecked: {
        width: "25%"
    },
    formReason: {
        display: "flex",
        justifyContent: "center"
    },
    iconSave: {
        fontSize: "1.3rem",
        paddingRight: "0.3rem"
    },
    labelError: {
        fontSize: "0.8rem",
        color: "#f44336"
    }
}
const styles = theme => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
        width: "70%"
    },
    avatar: {
        backgroundColor: "#0000008a",
        alignSelf: "baseline",
        width: "25px",
        height: "25px",
        borderRadius: "0.3rem",
        fontWeight: 550,
        fontSize: "1em"
    }
});

const mapStateToProps = (state) => ({
    main: state.main
});

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(mainActions, dispatch)
    }
}

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(Survey));


// WEBPACK FOOTER //
// ./src/components/Surveys/Survey.js